import { render, staticRenderFns } from "./AvisosDePrivacidad.vue?vue&type=template&id=54607a05&"
import script from "./AvisosDePrivacidad.vue?vue&type=script&lang=js&"
export * from "./AvisosDePrivacidad.vue?vue&type=script&lang=js&"
import style0 from "./AvisosDePrivacidad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
